import styled from '@emotion/styled'
import {theme} from '../../../../core/theme'

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};
`

export const StepperButton = styled.button`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.radii.md};
  border: none;
  background: ${theme.colors.bg.brand};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const StepperValue = styled.span`
  min-width: 28px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.radii.md};
  background: ${theme.colors.bg.brand};
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
`

/* Editable twin of StepperValue — lets a rep type a quantity instead of
   clicking + repeatedly. Spinners are hidden; the +/- buttons are the stepper. */
export const StepperInput = styled.input`
  width: 36px;
  height: 22px;
  padding: 0 2px;
  text-align: center;
  border: 1px solid transparent;
  border-radius: ${theme.radii.md};
  background: ${theme.colors.bg.brand};
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  cursor: text;

  &:focus {
    outline: none;
    border-color: ${theme.colors.border.focus};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  appearance: textfield;
`
